import React from "react";
import "./WebDev.css";

const WebDev = () => {
  return (
    <section className="webdev">
      <h1>Modern Web Development Services to Propel Your Business</h1>
      <div className="content">
        <div className="left">
          <h3>What We Offer?</h3>
          <p>
            We offer innovative web development solutions designed to elevate your online presence and help your business thrive in the digital world.
          </p>
        </div>
        <div className="middle">
          <h3>Why Choose Us?</h3>
          <p>
            Our team of expert developers combines cutting-edge technology with creative design to deliver high-performance, secure, and scalable websites that align with your goals.
          </p>
        </div>
        <div className="right">
          <h3>Our Expertise</h3>
          <p>
            We specialize in responsive design, SEO optimization, and seamless user experiences to ensure your website stands out and performs exceptionally across all devices.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WebDev;
